import React, {useEffect} from 'react';
import {SingleOrderDetail} from '@/types/order'
//import {useSearchParams} from '@/utils/navigation';
import updateLineItem from '@/services/OrderService/updateLineItem'
import { useSnapshot } from 'valtio'
import state from '@/store'
interface Order3DPluginProps {
    orderDetail: SingleOrderDetail;
    setIs3DModalOpen:any;
    loadOrder:any;
}

const getCustomizerBaseUrl = (fallbackUrl: string): string => {
    const searchParams = new URLSearchParams(window.location.search)
    const urlParam =
        searchParams.get('customizer_url') || searchParams.get('customizerUrl') || searchParams.get('neatolabs')
    if (urlParam) return urlParam

    const hashMatch = window.location.hash.match(/#neatolabs=(.+)/)
    return hashMatch?.[1] || fallbackUrl
}

const buildCustomizerUrl = (baseUrl: string, params: Record<string, string | undefined>) => {
    const url = new URL(baseUrl)
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) url.searchParams.set(key, value)
    })
    return url.toString()
}

const getProductSectionId = (section: any) => {
    const elements = Array.isArray(section?.elements) ? section.elements : []
    const elementSectionId = elements.find((element: any) =>
        element?.sectionId || element?.section_id
    )

    // Order API's lowercase `id` is the order-section record ID. The customizer
    // needs the product-profile section ID, which is preserved on each element.
    return elementSectionId?.sectionId || elementSectionId?.section_id ||
        section?.product_section_id || section?.SectionID || section?.section_id || section?.ID
}

// Transform sections to include snake_case keys that 3DPlugin expects
const transformSectionsForPlugin = (sections: any[]) => {
    if (!sections) return []
    return sections.map((section: any) => ({
        ...section,
        // Map PascalCase keys to snake_case for 3DPlugin compatibility
        section_id: getProductSectionId(section),
        product_profile_id: section.ProductProfileID || section.product_profile_id,
    }))
}

// Inject original section IDs into data received from 3DPlugin before saving
const injectOriginalSectionIds = (dataString: string, originalSections: any[]) => {
    try {
        const data = typeof dataString === 'string' ? JSON.parse(dataString) : dataString
        if (data.sections && Array.isArray(data.sections) && originalSections) {
            data.sections = data.sections.map((section: any, index: number) => {
                // Try to match by section name first, fallback to index
                const originalSection = originalSections.find((os: any) =>
                    os.Name === section.name || os.name === section.name
                ) || originalSections[index]

                if (originalSection) {
                    // updateLineItem expects the order-section record ID here, not
                    // the product-profile section ID used inside the customizer.
                    const sectionId = originalSection.id || originalSection.ID || originalSection.section_id || section.section_id
                    // Get product profile ID
                    const productProfileId = originalSection.product_profile_id || originalSection.ProductProfileID || section.product_profile_id

                    console.log('Injecting IDs - section:', section.name, 'sectionId:', sectionId, 'productProfileId:', productProfileId)

                    return {
                        ...section,
                        section_id: sectionId,
                        product_profile_id: productProfileId,
                    }
                }
                return section
            })
        }
        return JSON.stringify(data)
    } catch (e) {
        console.error('Error injecting section IDs:', e)
        return dataString
    }
}

const Order3DPlugin = ({orderDetail,setIs3DModalOpen,loadOrder}: Order3DPluginProps) => {

	const {currentUser, companySetting} = useSnapshot(state)

	const PLUGIN_API_URL_V1 = import.meta.env.VITE_3D_PLUGIN_V1
    const PLUGIN_API_URL_V2 = import.meta.env.VITE_3D_PLUGIN_V2

	const DEFAULT_PLUGIN_API_URL = companySetting?.profile_version === 'v2' ? PLUGIN_API_URL_V2 : PLUGIN_API_URL_V1
	const PLUGIN_API_URL = getCustomizerBaseUrl(DEFAULT_PLUGIN_API_URL)

    //const newElementList: any[] = [];
    const storeName = currentUser?.selectedCompany?.store_name
	const iframeUrl = buildCustomizerUrl(PLUGIN_API_URL, {
		sku: orderDetail?.sku,
		store_name: storeName,
		disable_legal_compliance: 'true',
		disable_profanity_check: 'true',
		disable_create_new_product: 'true',
		orderPage: 'true',
	})

    // Transform sections to include snake_case keys
    const transformedSections = transformSectionsForPlugin(orderDetail?.sections)
    const productProfileId = transformedSections.find((section: any) =>
        section.product_profile_id
    )?.product_profile_id

	//searchParams.get("storeName") ? searchParams.get("storeName") : sessionStorage.getItem('storeName')
    const productData = {
        'id': orderDetail?.id,
        'main_product_id': orderDetail?.product.product_id,
        'main_variant_id': orderDetail?.product.variant_id,
        'product_profile_id': productProfileId,
        'modification_data': {
            'Base Price': "0",
            'Customized Price': "0",
            '_data': `{"sections":${JSON.stringify(transformedSections)}}`,
            '_eching_sections': "0",
            '_neatolabsCost': "0",
        },
        'modification_id': `${orderDetail?.id}_temp`,
        'quantity': orderDetail?.quantity,
        'store': storeName,
        'title': orderDetail?.name,
        'variant_id': orderDetail?.product.variant_id,
        'platform': 'admin-portal',
        'variants': [{
            available: true,
            'id': orderDetail?.product.variant_id,
            'is_enable_customization': orderDetail?.product.is_enable_customization,
            'price': orderDetail?.product.price,
            'sku': orderDetail?.sku,
            'title': orderDetail?.product.variant_name,
            'has_customization' : "true",
            'inventory_quantity': 1000000
        }]

    }



    let orderPlugin = {
        iframeMessages: {
            get:async (event: any) => {
                const receivedDataFromIframe = event?.data
                console.log("receivedDataFromIframe----",receivedDataFromIframe)
                if (Object.prototype.hasOwnProperty.call(receivedDataFromIframe, 'product-data')) {
                    const modificationIframe = document.getElementById("neatolabs-app") as HTMLIFrameElement;
                    modificationIframe?.contentWindow?.postMessage({"product-data": productData}, "*")
                }  else if (Object.prototype.hasOwnProperty.call(receivedDataFromIframe, 'add_to_cart')) {
                    if(receivedDataFromIframe?.properties?._data){
                        try {
                           // Inject original section IDs before saving
                           const updatedData = injectOriginalSectionIds(
                               receivedDataFromIframe.properties._data,
                               orderDetail?.sections
                           )
                           await updateLineItem(orderDetail?.order_id, productData.id, updatedData, receivedDataFromIframe.properties._neatolabsCost);
                            setIs3DModalOpen(false);
                            loadOrder();
                        } catch (error) {
                            console.error("Error updating line item:", error);
                        }
                    }

                }

            }
        }
    }
    useEffect(() => {
        window.addEventListener('message', orderPlugin.iframeMessages.get)
        return () => window.removeEventListener('message', orderPlugin.iframeMessages.get)

    }, [])

    return (< >
        <iframe id={'neatolabs-app'} allow="web-share"
                src={iframeUrl}
                height={'100%'} width={'100%'} title="description" ></iframe>
    </>);
};

export default Order3DPlugin;
